import templateUrl from "emun.invoice/invoice-print.htm";
import basicController from "servicestack/basic.controller.properties";
import open from "webmodals/open";

export default options =>
  open({
    size: options.size || "md",
    templateUrl: options.templateUrl || templateUrl,
    title: "Print Invoice",
    bindToController: true,
    controllerAs: "$ctrl",
    controller() {
      const $ctrl = this;
      $ctrl.title = "Print Invoice";
      $ctrl.request = Object.assign(
        {
          IncludeImage: false,
          IncludeBarcodes: false,
          OrderBy: "strProductID"
        },
        options.request
      );
      basicController($ctrl);
      $ctrl.getUrl = () =>
        `${$ctrl.$appConfig.serviceUrl}InvoicePrint/${
          $ctrl.request.id
        }?${Object.keys($ctrl.request)
          .map(key => key + "=" + $ctrl.request[key])
          .join("&")}`;
    }
  }).result;
